<script setup lang="ts">
defineProps<{
  label?: string
  title: string
  titleAccent?: string
  subtitle: string
}>()

defineSlots<{
  action?: () => any
}>()
</script>

<template>
  <div class="connections-hero">
    <div class="connections-hero-decor-1"></div>
    <div class="connections-hero-decor-2"></div>

    <div class="connections-hero-content">
      <div>
        <div class="connections-hero-label">{{ label || 'Connections by Venture360' }}</div>
        <h1 class="connections-hero-title">
          {{ title }} <span v-if="titleAccent">{{ titleAccent }}</span>
        </h1>
        <p class="connections-hero-sub">{{ subtitle }}</p>
      </div>

      <div v-if="$slots.action" class="connections-hero-action">
        <slot name="action" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.connections-hero {
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
  border-radius: 16px;
  padding: 32px 40px;
  margin-bottom: 24px;
  position: relative;
  overflow: hidden;
}

.connections-hero-decor-1 {
  position: absolute;
  right: -60px;
  top: -60px;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.04);
  pointer-events: none;
}

.connections-hero-decor-2 {
  position: absolute;
  right: 60px;
  bottom: -100px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: rgba(59, 136, 175, 0.2);
  pointer-events: none;
}

.connections-hero-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.connections-hero-label {
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 8px;
}

.connections-hero-title {
  font-size: 32px;
  color: white;
  line-height: 1.1;
  margin-bottom: 10px;
  font-weight: 700;
}

.connections-hero-title span {
  color: #3b88af;
  font-style: italic;
}

.connections-hero-sub {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.65);
  max-width: 440px;
  line-height: 1.6;
}

.connections-hero-action {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}

@media (min-width: 640px) {
  .connections-hero {
    padding: 40px 48px;
  }

  .connections-hero-title {
    font-size: 38px;
  }
}

@media (max-width: 640px) {
  .connections-hero {
    padding: 28px 24px;
  }

  .connections-hero-title {
    font-size: 28px;
  }

  .connections-hero-action {
    position: static;
    margin-top: 4px;
  }
}
</style>
